import gql from 'graphql-tag'

const staticDefaultQuery = ({ slug, limit = 1 }) => {
  return `staticPageCollection(where: { slug: "${slug}" }, limit: ${limit}) {
    items {
      title
      slug
      date
      featureImage {
      	url
      	description
      	width
      	height
    	}
      seoTitle
      canonicalLink
      metaDescription
      noIndex
      redirectUrl {
        slug
      }
      mainContent {
        json
      }
    }
  }`
}

export const staticPageQuery = slug => gql`
  query {
    ${staticDefaultQuery({ slug })}
  }
`